import { addLovedOne } from './addLovedOne';
import { assignLovedOneToCaller } from './assignLovedOneToCaller';
import { deleteLovedOne } from './deleteLovedOne';
import { fetchLovedOne } from './fetchLovedOne';
import { fetchLovedOnes } from './fetchLovedOnes';
import { removeLovedOneEmail } from './removeLovedOneEmail';
import { updateLovedOne } from './updateLovedOne';

export const lovedOneService = {
  addLovedOne,
  assignLovedOneToCaller,
  deleteLovedOne,
  fetchLovedOne,
  fetchLovedOnes,
  removeLovedOneEmail,
  updateLovedOne,
};
